'use client';

import {
  Box,
  Checkbox,
  FormControlLabel,
  FormLabel,
  TextField,
} from '@mui/material';
import {
  INTAKE_FAMILY_NAME_MAX_LENGTH,
  INTAKE_NO_FAMILY_NAME_LABEL,
  INTAKE_PLACEHOLDERS,
  intakeFieldLabelSx,
  intakeFieldSx,
} from '../intake-copy';

type Props = {
  value: string;
  noFamilyName: boolean;
  error?: string;
  onChange: (value: string) => void;
  onToggleNoFamilyName: (checked: boolean) => void;
  onBlur: () => void;
};

/** Keeps the typed value while the escape checkbox is ticked so unticking restores it. */
export function IntakeFamilyNameField({
  value,
  noFamilyName,
  error,
  onChange,
  onToggleNoFamilyName,
  onBlur,
}: Props) {
  return (
    <Box>
      <FormLabel sx={intakeFieldLabelSx} htmlFor="intake-family-name">
        Last name
      </FormLabel>
      <TextField
        id="intake-family-name"
        name="familyName"
        autoComplete="family-name"
        required={!noFamilyName}
        fullWidth
        size="small"
        placeholder={noFamilyName ? '' : INTAKE_PLACEHOLDERS.familyName}
        value={noFamilyName ? '' : value}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        error={Boolean(error)}
        helperText={error}
        aria-invalid={Boolean(error)}
        slotProps={{
          htmlInput: {
            maxLength: INTAKE_FAMILY_NAME_MAX_LENGTH,
            readOnly: noFamilyName,
          },
        }}
        sx={intakeFieldSx}
      />
      <FormControlLabel
        sx={{ ml: 0, mr: 0, mt: 0.25 }}
        control={
          <Checkbox
            checked={noFamilyName}
            onChange={e => onToggleNoFamilyName(e.target.checked)}
            size="small"
          />
        }
        label={INTAKE_NO_FAMILY_NAME_LABEL}
      />
    </Box>
  );
}
